import { Center, Text } from "@mantine/core";

const NoRowsDisplay = ({ component }) => {
  return (
    <Center h={"100%"}>{component || <Text>No element found</Text>}</Center>
  );
};

export default NoRowsDisplay;
